import React, { useEffect } from 'react';
import { Card, CardContent, Typography } from '@material-ui/core';
import { FuseAnimate } from '@fuse';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import RegisterForm from './RegisterForm';
import { makeStyles } from '@material-ui/styles';
import pJSON from '../../../../package.json';
import { useSelector } from 'react-redux';

const useStyles = makeStyles(theme => ({
	root: {
		backgroundImage: 'url("assets/images/backgrounds/dark-material-bg.jpg")',
		color: theme.palette.primary.contrastText
	}
}));

const Register = props => {
	const classes = useStyles();

	const register = useSelector(({ fuse }) => fuse.config.register);

	useEffect(() => {
		if (!register) props.history.push('/login');
	}, [register, props.history]);

	return (
		<div className={clsx(classes.root, 'flex flex-col flex-1 flex-shrink-0 p-24 md:flex-row md:p-0')}>
			<div className="flex flex-col flex-grow-0 items-center text-white p-16 text-center md:p-128 md:items-start md:flex-shrink-0 md:flex-1 md:text-left">
				<FuseAnimate animation="transition.expandIn">
					<img className="w-160 mb-16 " src="assets/images/logos/heidi.svg" alt="logo" />
				</FuseAnimate>

				<FuseAnimate delay={400}>
					<div className="max-w-640 mt-16">
						<Typography variant="subtitle1" color="inherit">
							Heidi platform, powered by On-Demand Data Center, gives companies the
							ability to spin up temporary or persistent data center infrastructure resources quickly, inexpensively,
							and on-demand. This intelligent cloud management system gives immediate access to all computational
							resources, whether on premise or in the cloud on any leading cloud provider.
						</Typography>
						<Typography variant="subtitle1" color="inherit" className="mt-16">
							Teams can automatically deploy and build clusters in the cloud, automatically run applications on those
							clusters, and then terminate the cloud resources on a daily, weekly, or even hourly basis.
						</Typography>
						<Typography variant="subtitle1" color="inherit" className="mt-16">
							The Heidi On-Demand Data Center includes all the necessary tools to provision compute power and run workloads in
							the cloud or on-premise. Access to all major cloud providers is preconfigured and built into the
							interface. (CLI or GUI)
						</Typography>
						<Typography variant="subtitle1" color="inherit" className="mt-16">
							Version{`  ${pJSON.version}`}
						</Typography>
					</div>
				</FuseAnimate>
			</div>

			<FuseAnimate animation={{ translateX: [0, '100%'] }}>
				<Card className="w-full max-w-400 mx-auto m-16 md:m-0" square>
					<CardContent className="flex flex-col items-center justify-center p-32 md:p-48 md:pt-64 ">
						<Typography variant="h6" className="md:w-auto mb-32 ">
							CREATE AN ACCOUNT
						</Typography>

						<RegisterForm {...props} />

						<div className="flex flex-col items-center justify-center pt-32 pb-24">
							<span className="font-medium">Already have an account?</span>
							<Link className="font-medium" to="/login">
								Login
							</Link>
						</div>

						<div className="flex flex-col items-center"></div>
					</CardContent>
				</Card>
			</FuseAnimate>
		</div>
	);
};

export default Register;
